import React, { useEffect, useState } from "react";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../../firebase-config";
import { notification } from "antd";
import styles from "../../../styles/Signin.module.css";
import { Link, useNavigate } from "react-router-dom";
import ArLogo from "../../../components/CssComponents/ArLogo/ArLogo";
import backbutton from "./backbutton.png";
import LoginInput from "../../../components/FlowComponents/LoginInput/LoginInput";
import LoginOtpVerify from "../../../components/FlowComponents/LoginOtpVerify/LoginOtpVerify";
import { findUserByUID } from "../../../service/findUsers/findUserByUID";

const TrainerSignin = () => {
  const navigate = useNavigate();
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [showSign, setShowSign] = useState(true);
  const [currentPhone, setCurrentPhone] = useState("");

  useEffect(() => {
    const recaptchaContainer = document.getElementById("recaptcha-container");
    if (recaptchaContainer) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            console.log("reCAPTCHA solved");
          },
        }
      );
    }
    // Cleanup on component unmount
    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }
    };
  }, []);

  const handleSignInClick = (phone) => {
    sendVerificationCode(phone);
    setCurrentPhone(phone);
    setShowSign(false);
  };

  const handleOtpVerify = (otpComing) => {
    verifyOtp(otpComing);
  };

  const sendVerificationCode = (phone) => {
    const appVerifier = window.recaptchaVerifier;
    signInWithPhoneNumber(auth, phone, appVerifier)
      .then((result) => {
        setConfirmationResult(result);
        notification.success({
          message: "Otp sent to your phone",
          placement: "topRight",
          duration: 3,
        });
      })
      .catch((error) => {
        notification.error({
          message: "Failed to send OTP",
          description: `Please Try Again`,
          placement: "topRight",
          duration: 3,
        });
      });
  };

  const verifyOtp = (otp) => {
    if (!confirmationResult) {
      notification.success({
        message: "OTP Request Needed",
        description: "First request the OTP",
        placement: "topRight",
        duration: 3, // Display for 3 seconds
      });
      return;
    }
    confirmationResult
      .confirm(otp)
      .then(async (result) => {
        const user = result.user;
        const userDetails = await findUserByUID(user.uid);
        if (!userDetails || userDetails.userTypes !== "club_trainer") {
          notification.info({
            message: "User Details not found",
            description: `Redirecting to register in 5 seconds`,
            placement: "topRight",
            duration: 5,
          });
          setTimeout(() => {
            navigate("/trainer?action=register", { replace: true });
          }, 5000);
        }

        navigate("/trainer/dashboard", { replace: true });

        notification.success({
          message: "Phone number & user verified",
          placement: "topRight",
          duration: 3,
        });
      })
      .catch((error) => {
        notification.error({
          message: "Verification Failed",
          description: `Error : ${error.message}`,
          placement: "topRight",
          duration: 3,
        });
      });
  };

  return (
    <>
      <div className={styles.signin}>
        <div className={styles.container}>
          {showSign ? (
            <></>
          ) : (
            <div onClick={() => setShowSign(true)} className={styles.icon}>
              <img
                className={styles.iconImage}
                src={backbutton}
                alt={"Back Button"}
              />
            </div>
          )}
          <div id="recaptcha-container"></div>
          <ArLogo />
          <div className={styles.heading}>Trainer Login</div>
          {showSign ? (
            <LoginInput onSignInClick={handleSignInClick} />
          ) : (
            <LoginOtpVerify
              onOtpVerify={handleOtpVerify}
              onResendOtp={() => sendVerificationCode(currentPhone)}
            />
          )}
          <Link
            to="/trainer?action=register"
            style={{
              textDecoration: "none",
            }}
          >
            <p className={styles.naa}>
              Need an account? <span>Register</span>
            </p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default TrainerSignin;
